<template>
	<div class="user" v-if="id === 'new'">
		<h2>Создать пользователя</h2>
		<uiInput
			v-model="newUser.phone"
			:label="'Телефон*'"
			placeholder="+7 000 000 0000"
			style="margin-bottom: 10px"
			mask="+7 999 999 9999"
		/>
		<uiInput
			v-model="newUser.name"
			:label="'Имя*'"
			placeholder="Имя"
			style="margin-bottom: 10px"
		/>
		<uiInput
			v-model="newUser.surname"
			:label="true"
			placeholder="Фамилия"
			style="margin-bottom: 30px"
		/>
		<uiButton @click="createUser" :loading="loading" :disabled="!newUserValid">
			Создать
		</uiButton>
	</div>
	<div class="view" v-else-if="user">
		<div class="user">
			<h2>{{ user.surname }} {{ user.name }} {{ user.midname }}</h2>
			<div class="info">{{ user.phone }}</div>
			<div class="info global-id">{{ user.id }}</div>
			<uiButton color="grey" @click="openChat" style="margin-top: 10px">
				Открыть чат
			</uiButton>
			<uiDevider />
			<div class="info">С нами {{ userAge }}</div>
			<div class="info">Потратил: {{ user.spend || 0 }} ₽</div>
			<div class="info">Заказов: {{ user.orders || 0 }}</div>
			<div class="info">Бонусов сейчас: {{ user.bonuses || 0 }}</div>
			<div class="info">Бонусов потратил: {{ user.bonusesSpend || 0 }}</div>
			<div class="info">Пригласил друзей: {{ user.invited || 0 }}</div>
			<div class="info">Активных друзей: {{ user.invitedActive || 0 }}</div>

			<uiDevider />

			<uiInput
				v-model="user.surname"
				:label="true"
				placeholder="Фамилия"
				style="margin-bottom: 10px"
			/>

			<uiInput
				v-model="user.name"
				:label="true"
				placeholder="Имя"
				style="margin-bottom: 10px"
			/>

			<uiInput
				v-model="user.midname"
				:label="true"
				placeholder="Отчество"
				style="margin-bottom: 10px"
			/>

			<template v-if="$isGod()">
				<uiButton @click="makeAdmin" v-if="!isAdmin" color="grey">
					Сделать админом
				</uiButton>
				<uiDropdown
					multiple
					:options="roles"
					v-model="userRoles"
					label="Роли"
					v-else
				/>

				<div class="tfa" style="margin-top: 10px" v-if="tfa">
					{{ tfa }}
				</div>

				<uiButton
					@click="makeTfa"
					v-if="isAdmin && noTfa"
					color="grey"
					:loading="loading"
					style="margin-top: 10px"
				>
					Создать TFA
				</uiButton>
			</template>

			<uiDevider />

			<uiButton @click="saveUser" :loading="loading" style="margin-bottom: 10px">
				Сохранить
			</uiButton>
			<uiButton @click="removeUser" color="grey"> Удалить </uiButton>
		</div>

		<div class="flex-1 side">
			<uiFold title="Бонусы" header-width="280">
				<UserBonuses :user="user.id" @save="updateBonuses" />
			</uiFold>

			<uiFold title="Подписки" header-width="280">
				<UserSubscriptions :id="user.id" />
			</uiFold>

			<!-- <uiFold title="Заказы">
				<UserOrders :user="user.id" />
			</uiFold> -->
		</div>
	</div>
	<uiPreload v-else />
</template>

<script>
import { API } from '@/config'
import { formatDistanceToNow } from 'date-fns'
import { ru } from 'date-fns/locale'
import VLD from '@/utils/validate'
import UserBonuses from '@/components/UserBonuses'
import UserOrders from '@/components/UserOrders'
import UserSubscriptions from '@/components/UserSubscriptions'

export default {
	name: 'UserPage',
	components: {
		UserBonuses,
		UserOrders,
		UserSubscriptions,
	},
	props: {
		id: String,
	},
	data() {
		return {
			loading: false,
			user: null,
			newUser: {
				phone: '',
				name: '',
				surname: '',
				midname: '',
			},
			roles: ['god', 'support', 'medic'],
			chats: [],
			tfa: null,
		}
	},
	computed: {
		isAdmin() {
			if (!this.user) return
			return this.user.roles.includes('admin')
		},
		noTfa() {
			if (!this.isAdmin) return
			if (this.user.auth && !this.user.auth.tfa) return true
		},
		userAge() {
			return formatDistanceToNow(new Date(this.user.createdAt), {
				locale: ru,
			})
		},
		newUserValid() {
			return (
				VLD.check(this.newUser.phone.replace(/\s+/g, ''), 'phoneRaw') &&
				this.newUser.name.length > 1
			)
		},
		userRoles: {
			get() {
				return this.user.roles.filter((r) => r !== 'client')
			},
			set(nv) {
				this.user.roles = nv
				this.user.roles.push('client')
			},
		},
	},
	activated() {
		if (this.id !== 'new') this.loadUser()
	},
	methods: {
		onChange() {},
		async loadUser() {
			if (this.loading) return
			this.loading = true

			let [user, chats] = await Promise.all([
				this.$http.get(API.USERS.get + this.id),
				this.$http.get(API.CHATS.forUser + this.id),
			])
			if (!user.data || user.data.err) this.$notify('Не могу найти юзера')
			if (!chats.data || chats.data.err) this.$notify('Не могу найти юзера')

			if (user.data.surname === false) user.data.surname = ''
			this.user = user.data
			this.tfa = user.data.tfa

			this.chats = chats.data

			this.loading = false
		},
		async createUser() {
			if (this.loading) return
			this.loading = true

			let payload = JSON.parse(JSON.stringify(this.newUser))
			payload.phone = payload.phone.replace(/\s+/g, '')

			let { data } = await this.$http.post(API.USERS.create, payload)
			if (!data || data.err) this.$notify(data.err || 'Не могу создать юзера')

			this.loading = false
			if (data.id) {
				this.$router.replace('/users/' + data.id)
				this.$nextTick(() => {
					this.newUser = {
						phone: '',
						name: '',
						surname: '',
						midname: '',
					}
					this.loadUser()
				})
			}
		},
		async saveUser() {
			if (this.loading) return
			this.loading = true

			let payload = {
				id: this.user.id,
				name: this.user.name,
				surname: this.user.surname,
				midname: this.user.midname,
				roles: this.user.roles,
			}

			let { data } = await this.$http.post(API.USERS.update, payload)
			if (!data || data.err) {
				this.$notify('Не могу обновить юзера')
				return (this.loading = false)
			}

			this.user = data
			if (data.roles.includes('admin'))
				this.$store.commit('updateInArray', { path: 'admins', data: data })

			this.loading = false
		},
		async makeAdmin() {
			if (!this.user) return
			this.user.roles.push('admin')
		},
		async makeTfa() {
			if (this.loading) return
			this.loading = true

			let { data } = await this.$http.post(API.USERS.tfa, { id: this.user.id })
			if (!data || data.err) {
				this.$notify('Не могу обновить юзера')
				return (this.loading = false)
			}

			this.tfa = data.tfa
			this.loading = false
		},
		async removeUser() {
			let confirm = await this.$confirm('Точно удаляем?')
			if (!confirm) return

			let confirm2 = await this.$confirm('Подумай еще раз')
			if (!confirm2) return

			if (this.loading) return
			this.loading = true

			let { data } = await this.$http.post(API.USERS.delete, { id: this.id })
			if (!data || data.err) this.$notify('Не могу удалить юзера')
			else this.$router.replace('/users')
			this.loading = false
		},
		openChat() {
			let chat = this.chats.find((c) => c.kind === 'support')
			if (!chat) return
			this.$router.push('/chats/' + chat.id)
		},
		updateAddress(e) {
			this.user.addresses = e
		},
		updateBonuses(e) {
			this.user.bonuses = e
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
	display: flex;
	// padding: 0 20px;
}

.user {
	width: 280px;
	padding: 0 20px;
	height: calc(100vh - 60px);
	overflow: auto;
	border-right: 2px solid @grey;

	.info {
		font-size: 14px;
		opacity: 0.6;
	}
}

.side {
	padding: 0 20px;
	height: calc(100vh - 60px);
	overflow: auto;
}
</style>
